<template>
  <div class="public-panel">
    <img src="@/assets/images/header-logo-white.svg" />

    <div class="info-box" v-if="formErrors.token.length">
      <p v-for="(error, index) in formErrors.token" :key="index">
        {{error}}
      </p>
      <u @click="$router.push({name: 'Signup'})">Signup Now!</u>
    </div>

    <div class="form" v-else>
      <md-field>
        <label>Email</label>
        <md-input v-model="email" disabled />
      </md-field>

      <md-field :class="{'input-error': $v.companyName.$error || formErrors.company_name.length}">
        <label>Company Name</label>
        <md-input v-model="companyName" @blur="$v.companyName.$touch()" />
      </md-field>
      <h6 class="error-message" v-if="$v.companyName.$error">Please provide Company Name</h6>
      <error-info v-else :errorList="formErrors.company_name" />

      <md-field :class="{'input-error': $v.password.$error || formErrors.password.length}">
        <label>Password</label>
        <md-input v-model="password" @blur="$v.password.$touch()" type="password" />
      </md-field>
      <h6 class="error-message" v-if="$v.password.$error">Please enter the Password with atleast {{$v.password.$params.minLength.min}} characters</h6>
      <error-info v-else :errorList="formErrors.password" />

      <md-field :class="{'input-error': $v.confirmPassword.$error || formErrors.password_confirmation.length}">
        <label>Confirm Password</label>
        <md-input v-model="confirmPassword" @blur="$v.confirmPassword.$touch()"
                  type="password" @keyup.enter="submit" />
      </md-field>
      <h6 class="error-message" v-if="$v.confirmPassword.$error && !$v.confirmPassword.required">Please enter the Password again</h6>
      <h6 class="error-message" v-else-if="$v.confirmPassword.$error && !$v.confirmPassword.sameAs">The Confirm Password does not match</h6>
      <error-info v-else :errorList="formErrors.password_confirmation" />

      <button @click="submit">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import ErrorInfo from '@/components/global/ErrorInfo'

import ApiServices from '@/services/api/signup'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import { checkFormErrors } from '@/utils/helpers'

export default {
  name: 'Verification',
  components: { ErrorInfo },
  data () {
    return {
      token: null,
      email: null,
      companyName: null,
      password: null,
      confirmPassword: null,
      formErrors: {
        company_name: [],
        password: [],
        password_confirmation: [],
        token: []
      }
    }
  },
  validations: {
    companyName: {
      required
    },
    password: {
      required,
      minLength: minLength(8)
    },
    confirmPassword: {
      required,
      sameAs: sameAs('password')
    }
  },
  watch: {
    companyName () {
      this.formErrors.company_name = []
    },
    password () {
      this.formErrors.password = []
    },
    confirmPassword () {
      this.formErrors.password_confirmation = []
    }
  },
  created () {
    this.token = this.$route.params.token
    this.verifyLink()
  },
  methods: {
    ...mapMutations(['SET_USER_LOGGED_IN', 'SET_TARGET_PAGE']),
    checkFormErrors,
    verifyLink () {
      ApiServices.verifyLink({token: this.token}).then((response) => {
        this.email = response.data.email
      }).catch(error => {
        this.handleErrorResponse(error)
      })
    },
    submit () {
      this.$v.$touch()
      if (!this.$v.$error && !this.checkFormErrors(this.formErrors)) {
        let params = {
          company_name: this.companyName,
          password: this.password,
          confirm_password: this.confirmPassword,
          token: this.token,
          device_os: navigator.userAgent,
          device_app: navigator.appName
        }

        ApiServices.onboard(params).then((response) => {
          localStorage.setItem('access_token', response.data.token)
          this.SET_USER_LOGGED_IN(true)
          this.SET_TARGET_PAGE('ANY')
          this.$router.push({name: 'Dashboard'})
          window.gtag('event', 'conversion', {'send_to': 'AW-705039016'})
        }).catch(error => {
          this.handleErrorResponse(error)
        })
      }
    },
    handleErrorResponse (error) {
      let data = error.data
      if (typeof data.reason === 'object') {
        this.formErrors = {
          ...this.formErrors,
          ...data.reason
        }
      } else {
        this.formErrors.token = [data.reason || data.message]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/publicPanel.scss';

  .info-box {
    u {
      font-weight: 500;
      display: block;
      color: $primary;
      margin-top: 5px;
      cursor: pointer;
    }
  }
</style>
